<template>
    <b-modal
            body-class="p-0"
            cancel-disabled
            hide-footer
            id="imei-modal"
            ok-disabled
            title="">
        <div class="modal-body modal-body-lg pt-0">
            <h4 class="text-center">
                How to find your IMEI number
            </h4>
        </div>
        <div class="modal-body modal-body-lg pt-0">
            <h3 class="title"></h3>
            <p>
                An IMEI number is a unique code (normally 15 digits) to identify the exact model of device. Providing your IMEI number ensures the technicians are equipped with the exact parts required. There are a few different ways you can find it:
            </p>
            <ol>
                <li>
                    <strong>Dial the code:</strong> Dial <pre class="d-inline">*#06#</pre> using your handset's keypad.
                </li>
                <li>
                    <div>
                        <strong>On iPhone:</strong> Go to <pre class="d-inline">Settings > General > About</pre>.
                    </div>
                    <div>
                        <strong>On Android:</strong> Go to <pre class="d-inline">Settings > About Phone > Status</pre>.
                    </div>
                </li>
                <li>
                    <strong>On the packaging:</strong> If you have the original packaging for your phone, you can find the IMEI number on the barcode label.
                </li>
            </ol>
        </div>
    </b-modal>
</template>

<script>
    export default {
    }
</script>

<style scoped>

</style>